module.exports = __webpack_public_path__ + "3eae1c21162b3afe4d724520a5d26e46.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/singing-spear.webm
// module id = 646
// module chunks = 0